import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface SeverityIndicatorProps {
  value: number;
  onChange?: (value: number) => void;
  label: string;
  showLabel?: boolean;
  interactive?: boolean;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'severity' | 'accuracy';
}
// Mapping livelli -> label gravità
const severityLabels: Record<number, {
  label: string;
  color: string;
}> = {
  1: {
    label: 'Minimo',
    color: 'text-green-600'
  },
  2: {
    label: 'Lieve',
    color: 'text-yellow-600'
  },
  3: {
    label: 'Moderato',
    color: 'text-red-500'
  },
  4: {
    label: 'Grave',
    color: 'text-red-600'
  },
  5: {
    label: 'Critico',
    color: 'text-red-700'
  }
};
// Colori progressivi per i pallini (gravità)
const getSeverityDotColor = (level: number, currentValue: number): string => {
  if (level > currentValue) return 'bg-gray-300';
  if (currentValue <= 2) return 'bg-yellow-500';
  return 'bg-red-500';
};
// Colore accent per accuratezza
const getAccuracyDotColor = (level: number, currentValue: number): string => {
  if (level > currentValue) return 'bg-gray-300';
  return 'bg-teal-deep';
};
const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10'
};
export function SeverityIndicator({
  value,
  onChange,
  label,
  showLabel = true,
  interactive = true,
  size = 'md',
  variant = 'severity'
}: SeverityIndicatorProps) {
  const [hovered, setHovered] = useState(0);
  const displayValue = interactive && hovered > 0 ? hovered : value;
  const getDotColor = variant === 'accuracy' ? getAccuracyDotColor : getSeverityDotColor;
  return <div className="space-y-3" data-id="element-593">
      <label className="text-base font-semibold text-gray-700" data-id="element-594">{label}</label>

      <div className="flex gap-2" data-id="element-595">
        {[1, 2, 3, 4, 5].map(level => <motion.button key={level} type="button" disabled={!interactive} onClick={() => interactive && onChange?.(level)} onMouseEnter={() => interactive && setHovered(level)} onMouseLeave={() => interactive && setHovered(0)} whileTap={interactive ? {
        scale: 0.9
      } : {}} className={`${sizeClasses[size]} rounded-full transition-all flex items-center justify-center ${interactive ? 'hover:scale-110 cursor-pointer touch-manipulation' : 'cursor-default'}`} data-id="element-596">
            <div className={`w-full h-full rounded-full transition-all ${getDotColor(level, displayValue)}`} data-id="element-597" />
          </motion.button>)}
      </div>

      {/* Severity Label - only for severity variant */}
      {showLabel && value > 0 && variant === 'severity' && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex items-center gap-2" data-id="element-598">
          <span className="text-sm text-gray-500" data-id="element-599">Livello di gravità:</span>
          <span className={`text-base font-semibold ${severityLabels[value]?.color}`} data-id="element-600">
            {severityLabels[value]?.label}
          </span>
        </motion.div>}
    </div>;
}
// Export anche le label per riuso in altri componenti
export { severityLabels };